import { render, staticRenderFns } from "./SelectData.vue?vue&type=template&id=dea133e8&"
import script from "./SelectData.vue?vue&type=script&lang=js&"
export * from "./SelectData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports